import React, { useEffect, useState } from "react";
import { Amplify } from "aws-amplify";
import { signOut, getCurrentUser, fetchAuthSession } from "aws-amplify/auth";
import awsConfig from "./config/aws-config";
import LoginPage from "./LoginPage";
import SmokyQApp from "./components/SmokyQApp";
import { usersAPI } from "./services/api";

Amplify.configure(awsConfig);

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [userInfo, setUserInfo] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    checkAuthStatus();
    // periodic check every 5 minutes
    // const t = setInterval(checkAuthStatus, 5 * 60 * 1000);
    // return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuthStatus = async () => {
    try {
      setIsLoading(true);

      const session = await fetchAuthSession();
      const accessToken = session.tokens?.accessToken;

      if (!accessToken) {
        setIsAuthenticated(false);
        setUserInfo(null);
        setCurrentUser(null);
        return;
      }

      if (window.location.search.includes("code=")) {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }

      const user = await getCurrentUser();
      if (!user) {
        setIsAuthenticated(false);
        setUserInfo(null);
        setCurrentUser(null);
        return;
      }

      setUserInfo({
        username: user.username,
        userId: user.userId,
        email: session.tokens?.idToken?.payload?.email || null,
      });

      setIsAuthenticated(true);

      await loadUserData();
    } catch (error) {
      console.error("Auth check error:", error);
      setIsAuthenticated(false);
      setUserInfo(null);
      setCurrentUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  const loadUserData = async () => {
    try {
      const response = await usersAPI.getCurrent();
      setCurrentUser(response.data);
    } catch (error) {
      console.error("Failed to load user data:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut({ global: true });
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setIsAuthenticated(false);
      setUserInfo(null);
      setCurrentUser(null);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <SmokyQApp onLogout={handleLogout} currentUser={currentUser} />;
};

export default App;
